<template>
  <div class="row">
    <div class="col-md-12">
      <form>
        <div class="">
          <ul class="nav nav-tabs small">
            <li
              v-for="tab in tabData"
              :key="tab.id"
              @click="selectTab(tab.id)"
              :class="[currentTab == tab.id ? 'active' : 'li-tabs']"
            >
              {{ tab.name }}
            </li>
          </ul>
        </div>

        <div v-if="loading === true">
          <div class="centered">
            <a-spin />
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-sm-12">
            <div v-for="tab in tabData" :key="tab.id">
              <div v-if="tab.id == currentTab">
                <component :is="tab.component" v-bind="tab.component" />
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="![9,10].includes(currentTab)">
          <div class="col">
            <input
              type="submit"
              value="Update Client Profile"
              class="btn btn-primary"
              @click="onUpdate"
            />

            <button
              type="button"
              class="btn btn-primary ml-3"
              @click="setCloneClient"
            >
              Clone Client
            </button>
          </div>
        </div>
      </form>
    </div>
    <div v-if="![9,10].includes(currentTab)">
      <fieldset class="mt-4 ml-2">
        <legend>Delete client</legend>
        <form>
          <div class="row px-2">
            <div class="col-md-12">
              <div class="form-group">
                <label class="form-label" for="comments"
                  >Why is this client being deleted?</label
                >
                <textarea
                  cols="60"
                  rows="5"
                  name="comments"
                  class="form-control"
                  v-model="comment"
                ></textarea>
              </div>
              <div class="form-group mt-3">
                <input
                  type="Submit"
                  style="color: white;"
                  value="Delete this client"
                  class="btn btn-danger"
                  @click="onDelete"
                />
              </div>
            </div>
          </div>
        </form>
      </fieldset>
    </div>
  </div>
</template>
<script>
import BasicSettings from "./clienteditmodule/BasicSettings.vue";
import BravoModule from "./clienteditmodule/BravoModule";
import AceModule from "./clienteditmodule/AceModule";
import Miscellaneous from "./clienteditmodule/Miscellaneous";
import UserOptions from "./clienteditmodule/UserOptions";
import ClientAdmins from "./clienteditmodule/ClientAdmins";
import SeparateClient from "./clienteditmodule/SeparateClient";
import ShippingAddress from "./clienteditmodule/ShippingAddress";
import Funding from "./clienteditmodule/Funding";
import CatalogGrid from "./clienteditmodule/CatalogGrid"

export default {
  name: "EditClientForm",
  components: {
    BasicSettings,
    BravoModule,
    AceModule,
    Miscellaneous,
    UserOptions,
    ClientAdmins,
    SeparateClient,
    ShippingAddress,
    Funding,
    CatalogGrid
  },
  data() {
    return {
      loading: false,
      clientId: this.$route.params.Id,
      currentTab: 1,
      comment: "",
      tabData: [
        {
          id: 1,
          name: "Basic settings",
          component: BasicSettings,
        },
        {
          id: 2,
          name: "Bravo module edit info",
          component: BravoModule,
        },
        {
          id: 3,
          name: "Ace module edit info",
          component: AceModule,
        },
        {
          id: 4,
          name: "Miscellaneous",
          component: Miscellaneous,
        },
        {
          id: 5,
          name: "User options",
          component: UserOptions,
        },
        {
          id: 6,
          name: "Client admins",
          component: ClientAdmins,
        },
        {
          id: 7,
          name: "Separate client front page",
          component: SeparateClient,
        },
        {
          id: 8,
          name: "Shipping address",
          component: ShippingAddress,
        },
        {
          id: 9,
          name: "Funding",
          component: Funding,
        },
        {
          id: 10,
          name: "Catalog Grid",
          component: CatalogGrid,
        },
      ],
    };
  },
  computed: {
    client() {
      return this.$store.state.manageClients.client;
    },
  },
  methods: {
    setCloneClient() {
      this.$store.commit("cloneClient/SET_CLIENT", {
        id: Number(this.$route.params.Id),
        name: this.$route.params.name,
      });

      this.$router.push({
        name: "cloneClientForm",
      });
    },
    selectTab(selectedTab) {
      this.currentTab = selectedTab;
    },
    onUpdate(e) {
      e.preventDefault();
      if (this.client.taico_email != "") {
        if (
          !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(
            this.client.taico_email
          )
        ) {
          alert("Invalid email address");
          return;
        }
      }
      console.log(this.$route.params.Id);
      this.$store.dispatch("manageClients/updateClient", this.client);
      this.$router.push({
        name: "ClientUpdateScreen",
        params: { Id: this.$route.params.Id },
      });
    },
    onDelete(e) {
      e.preventDefault();
      if (this.comment === "") {
        alert("'Why is this client being deleted?' is a mandatory field");
        return;
      }
      this.$router.push({
        name: "ClientDeleteScreen",
        params: { Id: this.clientId },
      });
    },
  },

  created() {
    window.scrollTo(0, 0);
    this.loading = true;
    this.$store
      .dispatch("manageClients/fetchClientById", {
        clientId: this.clientId,
      })
      .then(() => {
        this.loading = false;
      });
  },
};
</script>

<style>
.nav {
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-tabs {
  border-bottom: 1px solid #ddd;
  list-style: none;
}

.li-tabs {
  font-size: 95%;
  list-style: none;
  border: 1px solid transparent;
  /* border-bottom-color: none; */
  text-decoration: none;
  color: #2980b9;
  display: inline-block;
  margin: 0px 8px 8px 0px;
  padding: 10px 15px;
  cursor: pointer;
  margin-bottom: -0.5px;
  /* border-radius: 4px 4px 0 0; */
}

.li-tabs:hover {
  background-color: #eee;
}

.active {
  font-size: 95%;
  list-style: none;
  border: 1px solid #ddd;
  border-bottom: none;
  text-decoration: none;
  color: #777;
  display: inline-block;
  margin: 0px 8px 8px 0px;
  padding: 10px 15px;
  cursor: pointer;
  margin-bottom: -0.5px;
  border-radius: 4px 4px 0 0;
}

.nav-tabs {
  padding-left: 0px;
  margin: 0px;
}

form label {
  font-size: 15px;
  font-weight: bold;
}

fieldset {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 1.4em;
  margin: 0 0 1.5em 0;
}

.form-switch .form-check-input {
  width: 3em;
  height: 1.3rem;
}

.form-check {
  padding-left: 2rem;
}

legend {
  position: absolute;
  font-size: 100%;
  width: auto;
  padding: 0px 5px;
  border: none;
  margin-top: -30px;
  font-weight: bold;
  background-color: white;
}

.small {
  font-size: 90%;
}

.centered {
  position: fixed;
  top: 50%;
  left: 62%;
  transform: translate(-50%, -50%);
  transform: -webkit-translate(-50%, -50%);
  transform: -moz-translate(-50%, -50%);
  transform: -ms-translate(-50%, -50%);
  color: darkred;
  z-index: 99999;
}
</style>
